export const userTypes = [
  "CUSTOMER",
  "API_USER",
  "SUB_AGENT",
  "CORPORATE"
]